import * as yup from 'yup'

const accountFormValidationSchema = yup
  .object({
    companyName: yup
      .string()
      .trim()
      .required('Company name is required')
      .min(3, 'Company name should contain at least ${min} characters')
  })
  .required()

export default accountFormValidationSchema
